export const VENDOR_CATEGORIES = [
    { id: 'Fabrication', name: 'Fabrication' },
    { id: 'Machining', name: 'Machining' },
    { id: 'MRO – Manufacturing or Trading', name: 'MRO – Manufacturing or Trading' },
    { id: 'Sheet Metal Parts', name: 'Sheet Metal Parts' },
    { id: 'Surface Treatment', name: 'Surface Treatment' },
    { id: 'Installation / Services', name: 'Installation / Services' },
    { id: 'Process / Special Process', name: 'Process / Special Process' },
    { id: 'Casting', name: 'Casting' },
    { id: 'Raw Material', name: 'Raw Material' },
];

export const SPECIALIZATION_CHOICES = VENDOR_CATEGORIES;

export const RISK_LEVEL_CHOICES = [
    { id: 'High', name: 'High' },
    { id: 'Medium', name: 'Medium' },
    { id: 'Low', name: 'Low' },
];

export const VENDOR_STATUS_CHOICES = [
    { id: 'pending_approval', name: 'Pending Approval' },
    { id: 'checked', name: 'Checked' },
    { id: 'on_hold', name: 'On Hold' },
    { id: 'approved', name: 'Approved' },
    { id: 'conditional', name: 'Conditional' },
    { id: 'rejected', name: 'Rejected' },
    { id: 'blacklisted', name: 'Blacklisted' },
    { id: 'quick_vendor', name: 'Quick Vendor' },
];

// Temporary bug-tracker requirement: show only Ganesh and Tushar for
// "Checked By" / "Approved By". Replace this with sales users filtered by
// vendor approval role/permission when the approval workflow is RBAC-backed.
export const VENDOR_APPROVERS = [
    { id: 'Ganesh', name: 'Ganesh' },
    { id: 'Tushar', name: 'Tushar' },
];
